// components/GTMProvider.tsx

import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { AnswerData } from "lib/api";
import { XOR } from "types/xor";

export type GTMProps = {
  form_name: string;
  product_name: string;
};

const GTM_ID = process.env.REACT_APP_GTM_ID || "";

export default function GTMProvider() {
  useEffect(() => {
    if (GTM_ID) {
      TagManager.initialize({ gtmId: GTM_ID });
    }
  }, []);

  return null;
}

type GTMAnswers = {
  [questionId: string]: string | number | (string | number)[];
};

export function formatAnswers(answers: AnswerData[]): GTMAnswers {
  return answers.reduce((acc, answer) => {
    acc[answer.questionId] =
      answer.value.length === 1 ? answer.value[0] : answer.value;
    return acc;
  }, {} as GTMAnswers);
}

type GTMSurveyProps = {
  formStep: number;
  quizStep: number;
  answers: GTMAnswers;
};

type GTMErrorProps = {
  error_name: string;
  section: "initializing-survey" | "submitting-answers" | "finalizing-survey";
  component_type: "error-message";
};

export function trackSubmission(
  eventProps: GTMProps & {
    formId: string;
    label: string;
  } & XOR<GTMSurveyProps, GTMErrorProps>,
) {
  TagManager.dataLayer({
    dataLayer: {
      event: "form_submission",
      "event.prop": {
        category: "content-click",
        action: "button-click",
        ...eventProps,
      },
    },
  });
}
